import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
export type TaskGroupFragment = {
  __typename: 'TaskGroup'
  groupId: string
  groupName: string
  totalTasksCount: number
  completedTasksCount: number
  newTasksCount: number
  unreadEmailsCount: number
}

export type AttachmentFragment = {
  __typename: 'Attachment'
  attachmentId: number
  name: string
  type: Types.AttachmentType
  url: string
  attachmentCategory?: Types.AttachmentCategory | null
}

export type TaskFragment = {
  __typename: 'Task'
  status: Types.TaskStatus
  responseUpdatedAt?: string | null
  followUpsCount: number
  taskId: number
  title: string
  description: string
  isFollowUpRequired: boolean
  unreadEmailsCount: number
  rejectedRemarks?: string | null
  handleId: string
  approveNextAction?: Types.ApprovalNextActionEnum | null
  taskTags: Array<{ __typename: 'TaskTag'; tagId: number; name: string }>
  responseAttachments: Array<{
    __typename: 'Attachment'
    attachmentId: number
    name: string
    type: Types.AttachmentType
    url: string
    attachmentCategory?: Types.AttachmentCategory | null
  }>
  historicalResponseAttachments: Array<{
    __typename: 'Attachment'
    attachmentId: number
    name: string
    type: Types.AttachmentType
    url: string
    attachmentCategory?: Types.AttachmentCategory | null
  }>
  learRequestConfig: {
    __typename: 'LEARRequestConfig'
    isPortalRedirection: boolean
    portalRedirectionContent: string
  }
}

export type EmailFragment = {
  __typename: 'Email'
  subject: string
  mailId: number
  body: string
  createdAt: string
  fromUser?: {
    __typename: 'MailUser'
    username: string
    emailAddress?: string | null
    avatarUrl?: string | null
  } | null
  attachments: Array<{
    __typename: 'Attachment'
    attachmentId: number
    name: string
    type: Types.AttachmentType
    url: string
    attachmentCategory?: Types.AttachmentCategory | null
  }>
}

export type TaskRequiredFieldsNotFilledFragment = {
  __typename: 'TaskRequiredFieldsNotFilled'
  templateId: string
  recordId: string
  requiredFields: Array<string>
  optionalFields: Array<string>
  createdAt: string
}

export const TaskGroupFragmentDoc = gql`
  fragment TaskGroup on TaskGroup {
    groupId
    groupName
    totalTasksCount
    completedTasksCount
    newTasksCount
    unreadEmailsCount
  }
`
export const AttachmentFragmentDoc = gql`
  fragment Attachment on Attachment {
    attachmentId
    name
    type
    url
    attachmentCategory
  }
`
export const TaskFragmentDoc = gql`
  fragment Task on Task {
    status
    responseUpdatedAt
    followUpsCount
    taskId
    title
    description
    isFollowUpRequired
    unreadEmailsCount
    taskTags {
      tagId
      name
    }
    responseAttachments {
      ...Attachment
    }
    historicalResponseAttachments {
      ...Attachment
    }
    learRequestConfig {
      isPortalRedirection
      portalRedirectionContent
    }
    rejectedRemarks
    handleId
    approveNextAction
  }
  ${AttachmentFragmentDoc}
`
export const EmailFragmentDoc = gql`
  fragment Email on Email {
    subject
    mailId
    body
    createdAt
    fromUser {
      username
      emailAddress
      avatarUrl
    }
    attachments {
      ...Attachment
    }
  }
  ${AttachmentFragmentDoc}
`
export const TaskRequiredFieldsNotFilledFragmentDoc = gql`
  fragment TaskRequiredFieldsNotFilled on TaskRequiredFieldsNotFilled {
    templateId
    recordId
    requiredFields
    optionalFields
    createdAt
  }
`
